// Demo data for offline interface
// Matches the core shape used by ManageBooks.tsx for list rendering

export interface IBookDemo {
  bookguid: string;
  title: string;
  author: string;
  series?: string;
  seriesBookNumber?: number;
  coverUrl?: string;
  uploadType?: string; // 'word' | 'epub' | 'pdf' (case-insensitive in consumer)
  language?: string;
  translation_progress?: Record<
    string,
    {
      status: 'complete' | 'in_progress' | 'not_started';
      percentage: number;
      translated_chapters: number;
      total_chapters: number;
    }
  >;
}

// Two sample public-domain books
export const demoBooks: IBookDemo[] = [
  {
    bookguid: 'demo-book-flatland',
    title: 'Flatland: A Romance of Many Dimensions',
    author: 'Edwin A. Abbott',
    series: '', // standalone
    coverUrl: '/demo/covers/flatland.png',
    uploadType: 'word',
    language: 'English',
    translation_progress: {}, // flags not shown in demo
  },
  {
    bookguid: 'demo-book-time-machine',
    title: 'The Time Machine',
    author: 'H. G. Wells',
    series: '', // standalone
    coverUrl: '/demo/covers/time-machine.png',
    uploadType: 'epub',
    language: 'English',
    translation_progress: {}, // flags not shown in demo
  },
];

// Paths to local original/translated HTML for future demo detail page wiring
export const demoTextPaths: Record<
  string,
  { original: string; translated_en: string }
> = {
  'demo-book-flatland': {
    original: '/demo/text/demo-book-flatland/original.html',
    translated_en: '/demo/text/demo-book-flatland/translated_en.html',
  },
  'demo-book-time-machine': {
    original: '/demo/text/demo-book-time-machine/original.html',
    translated_en: '/demo/text/demo-book-time-machine/translated_en.html',
  },
};
